var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-participants',{staticClass:"block participants",attrs:{"loading":_vm.isLoading,"participants":_vm.participants,"number-of-less-participants":8,"lazy":false},on:{"toggleSidebar":function($event){return _vm.$emit('toggleSidebar')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }